import Menu from './Compartido/Menu.jsx';
import TextosMarca from './Marca/TextosMarca.jsx';
import PropiedadesMarca from './Marca/PropiedadesMarca.jsx';
import Footer from './Compartido/Footer.jsx';

const Marca = (props) => {

    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosMarca
                eltexto={props.lamarca}
                ruta={props.ruta}
                lang={props.lang}
            />
            <PropiedadesMarca
                propiedades={props.propiedades}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Marca;
